import styled from 'styled-components'

export const Card = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  padding: 0 1rem;
  background: ${({ theme }) => theme.zds.colors.neutral1000};
  border-radius: ${({ theme }) => theme.zds.border.radius100};
  border: 1px solid ${props => props.theme.colors.colorDCE3ED};
  border-left: 4px solid ${props => props.theme.colors.color122d52};

  display: flex;
  row-gap: 0.625rem;
  flex-direction: column;
  justify-content: center;
`

export const Header = styled.div`
  position: relative;
  width: 100%;

  display: flex;
  justify-content: space-between;
`

export const Title = styled.h5`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 1rem;
  color: ${props => props.theme.colors.color2d3139};
`

export const TimeInformation = styled.span`
  position: relative;

  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 10px;
  color: ${props => props.theme.colors.color122d52};

  display: flex;
  align-items: center;
  gap: 0.25rem;

  svg {
    width: 10px;
    stroke: ${props => props.theme.colors.color122d52};
  }
`

export const DetailsContainer = styled.div`
  position: relative;
  width: 100%;

  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const Details = styled.p`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 1rem;
  color: ${props => props.theme.colors.color545e6c};
`

export const Divisor = styled.div`
  position: relative;
  height: 100%;
  width: 1px;

  background: ${props => props.theme.colors.colorDCE3ED};
`
